import { CLICK_CODE } from '@local/utils'

import { MarkerType } from '@web/components/Map/Map.constants'
import { markerZIndex } from '@web/components/Map/New/constant'
import { CreateMarkerIconOption, createMarkerIcon } from '@web/components/Map/New/marker.unit'
import { CustomMarkerOption } from '@web/components/Map/New/types'
import {
  BookingCardItemType,
  MapUpcomingItemType,
  OrderCardItemType,
} from '@web/ui/pages/home/components/Sections/UIUpComingSection'

export const convertMapUpcomingToMarker = (item: MapUpcomingItemType): CustomMarkerOption | null => {
  if (!item.coordinate) return null

  const displayName = item.placeName ?? item.businessName

  const iconOption: CreateMarkerIconOption = {
    type: MarkerType.UPCOMING,
    name: displayName,
    text: (item as BookingCardItemType).bookingDateTime ?? (item as OrderCardItemType).orderedDateTimeText,
  }

  const statusText =
    item.type === 'booking'
      ? item.bookingStatusCode !== 'RC03'
        ? '예약확인중'
        : ''
      : (item as OrderCardItemType).progressStates[(item as OrderCardItemType).stateIndex]
  const upcomingText = item.type === 'booking' ? (item as BookingCardItemType).bookingDateTime : ''

  return {
    id: item.id,
    position: {
      lat: item.coordinate.latitude,
      lng: item.coordinate.longitude,
    },
    title: displayName,
    icon: createMarkerIcon(iconOption),
    selectedIcon: createMarkerIcon({ ...iconOption, selected: true }),
    placeId: item.placeId,
    zIndex: markerZIndex.UPCOMING,
    clickCode: CLICK_CODE['timelinepg.markerupcoming'],
    upcomingInfo: {
      bookingTypeName: item.type === 'order' ? '주문' : '예약',
      statusText,
      upcomingText,
      landingUrl: item.landingUrl || '',
    },
  }
}
